import React from "react";
import { MediaCard } from "@/components/MediaCard";

export const fmtDuration = (s) => {
  if (!s || s <= 0) return null;
  const m = Math.floor(s / 60);
  const sec = Math.floor(s % 60);
  return `${m}:${String(sec).padStart(2, "0")}`;
};

// Legacy name kept for callers; renders THE single gallery card (portrait 3:4, feet-first framing).
// The old 16:9 "tile" variant was the source of the landscape-vs-portrait inconsistency between galleries.
export const MediaTile = ({ item, index = 0, onOpen }) => <MediaCard item={item} index={index} onOpen={onOpen} testid={`tile-${item.id}`} />;
